<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="三方字典名称" prop="tpDictLabel">
            <el-input
              v-model="formData.tpDictLabel"
              placeholder="请输入三方字典名称"
              maxlength="200"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="三方字典值">
            <el-input
              v-model="formData.tpDictValue"
              placeholder="请输入三方字典值"
              maxlength="100"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="系统字典名称" prop="sysDictLabel">
            <el-input
              v-model="formData.sysDictLabel"
              placeholder="请选择系统字典"
              readonly
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="openDictSelect()"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="拓展字段">
            <el-input
              v-model="formData.extend"
              placeholder="请输入拓展字段"
              clearable
              maxlength="100"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="d-flex mt-2">
      <div class="side-frame-warning"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Create：{{ formData.createByName || '--' }} at
          {{ formData.createTime || '--' }}
        </span>
      </div>
    </div>

    <ChooseDictOptions
      :visible.sync="chooseDictOptionsVisible"
      url="/openapi/client/dict/dictOptionSelect"
      :optionStatus="['Y']"
      :tableHeight="400"
      confirm-on-close
      reserve
      @confirm="chooseDictOptionsConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import ChooseDictOptions from '../choose-dict-options'
export default {
  components: { ChooseDictOptions },
  props: {
    disabled: { type: Boolean, default: false },
    appKey: { type: String, default: '' },
    clientDictCode: { type: String, default: '' },
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: { orgCode: '', sysDictLabel: '' },
      rules: {
        tpDictLabel: [
          {
            required: true,
            message: '请输入三方字典名称',
            trigger: 'blur',
          },
        ],
        sysDictLabel: [
          {
            required: true,
            message: '请选择系统字典',
            trigger: 'change',
          },
        ],
      },

      chooseDictOptionsVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.clientDictCode) return
      this.$api
        .sysOpenapiClientDictDetailApi({ clientDictCode: this.clientDictCode })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const res = await this.$api
        .sysOpenapiClientDictSaveApi({ ...this.formData, appKey: this.appKey })
        .catch(() => null)
      loading.close()
      if (!res) return

      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
      this.$emit('close')
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm('是否要保存更改', '提示信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '保存',
        cancelButtonText: '不保存',
      })
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
    chooseDictOptionsConfirm(data) {
      this.formData.sysDictCode = data.bizSysDictOptionCode
      this.formData.sysDictType = data.bizSysDictType
      this.formData.sysDictLabel = data.optionLabel
      this.formData.sysDictValue = data.optionValue
    },
    openDictSelect() {
      this.chooseDictOptionsVisible = true
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
